import { render, staticRenderFns } from "./bmcx.vue?vue&type=template&id=e37b3702&scoped=true"
import script from "./bmcx.vue?vue&type=script&lang=js"
export * from "./bmcx.vue?vue&type=script&lang=js"
import style0 from "./bmcx.vue?vue&type=style&index=0&id=e37b3702&prod&scoped=true&lang=scss"
import style1 from "./bmcx.vue?vue&type=style&index=1&id=e37b3702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37b3702",
  null
  
)

export default component.exports